import { ChatCard } from '@/components/ChatCard';
import { EmailCard } from '@/components/EmailCard';
import FinancialHelp from '@/components/FinancialHelp';
import { useViewport } from '@zopauk/react-components';
import { TelephoneCard } from '@/components/TelephoneCard';
import type { QuestionContext } from '@/utils/models/question';
import { type QuestionUrgentFragment, useQuestionQuery } from '@/utils/dato/generated';

const MOBILE_BREAKPOINT = 768;

/**
 * Can only be used in the context of a Question model
 */
const Urgent = ({ pageContext }: { pageContext: QuestionContext } & QuestionUrgentFragment) => {
  const { data } = useQuestionQuery({ slug: pageContext.slug });
  const { width } = useViewport();

  if (data?.question?.urgent) {
    const contact = data.question.contactInformation;
    const isMobile = (width ?? 0) <= MOBILE_BREAKPOINT;

    let link = contact?.telephoneLink || '';

    if (!isMobile && contact?.pageLink) {
      link = `/${contact?.pageLink.slug}`;
    }

    return (
      <>
        <div className="px-5 mx-auto max-w-[700px] mb-8 lg:mb-10">
          <ChatCard
            description={data.question.contactInformation?.descriptionChatCard || ''}
            title={data.question.contactInformation?.titleChatCard || ''}
          />

          {data.question?.contactInformation?.telephoneLink ? (
            <TelephoneCard
              description={
                data.question.contactInformation.openingTimes ? data.question.contactInformation.openingTimes : null
              }
              telephoneText={data.question.contactInformation.telephone || ''}
              title={data.question.contactInformation.titlePhoneCard || ''}
              telephoneLink={link}
            />
          ) : null}

          {data.question?.contactInformation?.email ? (
            <EmailCard email={data.question?.contactInformation?.email} />
          ) : null}
        </div>

        {data.question.contactInformation?.showFinancialAdvice && data.financialAdvice?.contactInformation ? (
          <FinancialHelp {...data.financialAdvice} />
        ) : null}
      </>
    );
  }

  return null;
};

export default Urgent;
